import { render, staticRenderFns } from "./QueriesSavedQueries.vue?vue&type=template&id=041d6959&scoped=true&"
import script from "./QueriesSavedQueries.vue?vue&type=script&lang=ts&"
export * from "./QueriesSavedQueries.vue?vue&type=script&lang=ts&"
import style0 from "./QueriesSavedQueries.vue?vue&type=style&index=0&id=041d6959&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041d6959",
  null
  
)

export default component.exports